import React, {Component} from "react";
import {Divider, MenuItem, Select, Stack, Tooltip} from "@mui/material";
import Line from "./Line";
import {mapDrawStateToProps} from "../../../redux_reducers/utils";
import {connect} from "react-redux";
import {Loading} from "../components/components";
import Circle from "./Circle";
import FreeLine from "./FreeLine";
import FreeHand from "./FreeHand";
import Rectangle from "./Rectangle";
import Polygon from "./Polygon";
import MagicTool from "./MagicTool";
import {setActiveAllSelectInteractions} from "../utils/map_utils";
import {notifySuccess} from "../utils/display.notification";
import {AnnotationsConstants} from "../../../utils/const";
import CircleIcon from "@mui/icons-material/Circle";
import {updateSelectedDrawColor, updateSelectedDrawWidth} from "../../../redux_actions/gamma.state.action";
import RemoveIcon from "@mui/icons-material/Remove";
import Arrow from "./Arrow";
import {aclPermissions, hasPermissions} from "../../../const/ACLPermissions";
import cookie from "react-cookies";
import {notNull} from "../../../utils/utils";

class DrawTools extends Component {

	constructor(props) {
		super(props);

		this.state = {
			selected: null,
			isColorTooltipOpen: false,
			isWidthTooltipOpen: false,
			isDefaultColorPresent: false,
		}
	}

	componentDidMount() {
		let defaultColor = (cookie.load("organisation_setting") || {})["default_annotation_color"];
		if(notNull(defaultColor)) {
			this.props.dispatch(updateSelectedDrawColor(defaultColor))
			Object.values(AnnotationsConstants.ANNO_COLORS).forEach(color => color === defaultColor &&
				this.setState({isDefaultColorPresent: true}))
		}

		document.addEventListener('click', this.handleDocumentClick);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleDocumentClick);
	}

	handleDocumentClick = (event) => {
		if (this.state.isColorTooltipOpen) {
			const tooltipElement = document.getElementById('anno-colors');
			if (tooltipElement && !tooltipElement.contains(event.target)) {
				this.toggleColorTooltip(false);
			}
		}
		if (this.state.isWidthTooltipOpen) {
			const tooltipElement = document.getElementById('anno-widths');
			if (tooltipElement && !tooltipElement.contains(event.target)) {
				this.toggleWidthTooltip(false);
			}
		}
	};

	toggleColorTooltip = (open) => {
		this.setState({isColorTooltipOpen: open});
	};
	changeDrawingColor = e => {
		this.props.dispatch(updateSelectedDrawColor(e.target.value));
	}
	getColorDropBarComponent = () =>
		<Tooltip title={"Colors"} placement={"bottom"} id={'anno-colors'} className='Colours-forTour'
				 onMouseEnter={() => this.toggleColorTooltip(true)}
				 onMouseLeave={() => this.toggleColorTooltip(false)}
				 open={this.state.isColorTooltipOpen}>
			<Select variant={"filled"} value={this.props.selectedDrawColor.toLowerCase()}
					onChange={(e) => this.changeDrawingColor(e)}>
				{!this.state.isDefaultColorPresent && <MenuItem value={this.props.selectedDrawColor.toLowerCase()}>
					<CircleIcon sx={{color: this.props.selectedDrawColor.toLowerCase()}}/>
				</MenuItem>}
				{Object.values(AnnotationsConstants.ANNO_COLORS).map(color =>
					<MenuItem value={color.toLowerCase()}>
						<CircleIcon sx={{color: color.toLowerCase()}}/>
					</MenuItem>)}
			</Select>
		</Tooltip>;

	toggleWidthTooltip = (open) => {
		this.setState({isWidthTooltipOpen: open});
	};
	changeDrawingWidth = e => {
		this.props.dispatch(updateSelectedDrawWidth(e.target.value));
	}
	getWidthDropBarComponent = () =>
		<Tooltip title={"Anno Width"} placement={"bottom"} id={'anno-widths'} className='Anno-Width-forTour'
				 onMouseEnter={() => this.toggleWidthTooltip(true)}
				 onMouseLeave={() => this.toggleWidthTooltip(false)}
				 open={this.state.isWidthTooltipOpen}>
			<Select variant={"filled"} value={this.props.selectedAnnoWidth}
					onChange={(e) => this.changeDrawingWidth(e)}>
				{Object.values(AnnotationsConstants.ANNO_WIDTH).map(width => (
					<MenuItem value={width}>
						<RemoveIcon sx={{fontSize: '24px', stroke: '#fff', strokeWidth: `${width}`}}/>
					</MenuItem>
				))}
			</Select>
		</Tooltip>

	onSelect = tool => this.setState({selected: tool !== this.state.selected && tool},
		() => {
			if (tool.id === AnnotationsConstants.TOOL_TYPE.ARROW) {
				this.state.selected && notifySuccess('drawTool', 'Click on the same point again to complete the Arrow');
			} else {
				this.state.selected && notifySuccess('drawTool', 'Press Escape/Right Click/Click on annotation ' +
					'tool again to stop drawing annotations');
			}
			setActiveAllSelectInteractions(this.props.slidemap, !this.state.selected);
		});

	render() {
		if (!this.props.layer)
			return <Loading/>;
		return <Stack direction="row" spacing={1}>
			{[
				<Divider orientation="vertical" flexItem/>,
				this.getColorDropBarComponent(),
				hasPermissions([aclPermissions.anno_width_app]) && this.getWidthDropBarComponent(),
				hasPermissions([aclPermissions.arrow_anno_app]) && <Arrow {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<Line {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<FreeLine {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<FreeHand {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<Circle {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<Rectangle {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<Polygon {...this.props} selected={this.state.selected} onSelect={this.onSelect} />,
				<MagicTool {...this.props} selected={this.state.selected} onSelect={this.onSelect} loading={this.props.magicToolDataRetrievalOngoing}/>,
				<Divider orientation="vertical" flexItem/>
			].filter(Boolean)}
		</Stack>
	}
}

export default connect(mapDrawStateToProps)(DrawTools);
